import React from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { RecurrencesParams } from 'models/Recurrences'
import BodyModalNewChargeOrRecurrence from 'templates/Customers/Modals/BodyModalNewChargeOrRecurrence/BodyModalNewChargeOrRecurrence'

interface ModalEditRecurrenceUnifiedProps {
  onClose: (get: boolean) => void
  uuid: string
  recurrence: RecurrencesParams
  refetch?: () => void
  nameCustomer?: string
  open: boolean
}

/**
 * Componente unificado para edição de recorrências
 * Utiliza o mesmo componente de criação de cobranças/recorrências, mas no modo de edição
 */
const ModalEditRecurrenceUnified: React.FC<ModalEditRecurrenceUnifiedProps> = ({
  onClose,
  uuid,
  recurrence,
  refetch,
  nameCustomer,
  open
}) => {
  const handleClose = (refresh?: boolean) => {
    onClose(!!refresh)
  }

  return (
    <Modal
      disablePortal={false}
      handleClose={() => handleClose(false)}
      open={open}
      width="100%"
      maxWidth="80vw"
      maxHeight="90vh"
      height="auto"
    >
      <BodyModalNewChargeOrRecurrence
        handleCloseModal={() => handleClose(false)}
        onClose={() => handleClose(true)}
        isCharge={false}
        isEdit={true}
        editType="recurrence"
        editData={recurrence}
        uuid={uuid}
        nameCustomer={nameCustomer}
        revalidateTable={refetch}
      />
    </Modal>
  )
}

export default ModalEditRecurrenceUnified
